var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"subscription-edit"}},[_c('h2',[_vm._v("Edit Subscription #"+_vm._s(_vm.subscriptionId))]),_vm._v(" "),_c('subscription-form',{attrs:{"subscriptionId":_vm.subscriptionId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9278eca0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubscriptionEdit.vue
// module id = 1253
// module chunks = 1